// extracted by mini-css-extract-plugin
export default {"container":"Partners_container__cs6z+","title":"Partners_title__z-mE3","list":"Partners_list__8cJWV","image":"Partners_image__ul-6k"};